export const iconFontAwesomeHumanitarianPersonMilitaryPointing = (
	<i className="fa-solid fa-person-military-pointing"></i>
);
